// 保存（作りかけのオートセーブ・最後に完成したキャラ）（2026-10-21 に app.js から分けた）
import { S } from './state.js';
import { SERVICE } from './config.js';
import { saveObject } from './core/savedata.js';
import { unzip, zip, zipNow } from './core/zlib.js';
import { histTouch } from './history.js';
import type { SaveData } from './types.js';

// ---- 保存（作りかけのオートセーブ・最後に完成したキャラ・セーブ・ロードの 9 スロット） ----
// 置き場所と形は本物の CHOCO と同じ。本物とモックで同じキャラを開ける（本番で今の作りかけ・スロットをそのまま引き継ぐため）:
//   作りかけ = localStorage の chibi_auto、最後に完成したキャラ = chibi_save（どちらも保存データの JSON を圧縮して URL エンコード。chibi.saveChara）
//   スロット = IndexedDB charatSaveSlots の chibi:1〜100 に { maker, text: 圧縮した保存データ, thumb: 小さな PNG, name: URL エンコードした名前, time }（slots.js）
// 前の画面は作りかけをカテゴリを替えたとき・完成・名前の決定のときだけ残した（パーツや色を変えてすぐ閉じると消える）。この画面は変えるたびに少しして残し、
// ページを離れるときにも残す
export const AUTO_KEY = SERVICE + '_auto', SAVE_KEY = SERVICE + '_save';
// 絵を作るだけのモード（page.php の ?render=1。「声で動かす」が見えない iframe で開く）では、作りかけ・完成のキャラを書かない
// （目・口を替えたキャラを当てるので、書くと本人の作りかけが替わってしまう）
const RENDER = !!window.CREATE_RENDER;
// 書く（圧縮はブラウザの CompressionStream で、少し後に書き終わる。Promise）。同じキーにもっと新しいものを書いたら、古い方は書かない
const writeSeq: Record<string, number> = {}, writing: Record<string, number> = {};
export function writeStored(key: string, obj: SaveData): Promise<boolean> {
  if (RENDER) return Promise.resolve(false);
  const seq = (writeSeq[key] = (writeSeq[key] || 0) + 1);
  writing[key] = (writing[key] || 0) + 1;
  return zip(JSON.stringify(obj)).then((z) => {
    if (seq !== writeSeq[key]) return false;
    try { localStorage.setItem(key, encodeURIComponent(z)); return true; } catch (e) { return false; }
  }, () => false).then((ok) => { writing[key]--; return ok; });
}
// すぐに書く（ページを離れるとき。圧縮しない zlib なので待たない）
export function writeStoredNow(key: string, obj: SaveData) {
  if (RENDER) return false;
  writeSeq[key] = (writeSeq[key] || 0) + 1;
  try {
    localStorage.setItem(key, encodeURIComponent(zipNow(JSON.stringify(obj))));
    return true;
  } catch (e) { return false; }
}
export function scheduleAutosave() {
  histTouch();
  if (!S.autosaveReady) return;
  S.autosaveDirty = true;
  clearTimeout(S.autosaveTimer);
  S.autosaveTimer = setTimeout(flushAutosave, 400);
}
// アプリ内ブラウザから開き直してきたキャラ（URL の #chara=、additional.js の charaCarryUrl が作る）を作りかけに入れる（Promise）。
// 壊れたデータは入れない。URL からはすぐ消す（前は additional.js がしていたのと同じ）
export function takeCarried() {
  const m = location.hash.match(/^#chara=([\w-]+)$/);
  if (!m || RENDER) return Promise.resolve();
  let z = null;
  try { z = atob(m[1].replace(/-/g, '+').replace(/_/g, '/')); } catch (e) {}
  history.replaceState(null, '', location.pathname + location.search);
  if (z === null) return Promise.resolve();
  return unzip(z).then((t) => {
    JSON.parse(t);
    writeSeq[AUTO_KEY] = (writeSeq[AUTO_KEY] || 0) + 1;
    localStorage.setItem(AUTO_KEY, encodeURIComponent(z));
  }).catch(() => {});
}
// additional.js がアプリ内ブラウザの案内で使う「今のキャラの圧縮データ」（オートセーブと同じもの。すぐに返す）
export function carryText() {
  let v = null;
  try { v = localStorage.getItem(AUTO_KEY); } catch (e) {}
  if (S.autosaveDirty || writing[AUTO_KEY] || !v) {
    clearTimeout(S.autosaveTimer);
    S.autosaveDirty = false;
    writeStoredNow(AUTO_KEY, saveObject());
    try { v = localStorage.getItem(AUTO_KEY); } catch (e) {}
  }
  return v ? decodeURIComponent(v) : '';
}
// now: ページを離れるときなど、すぐに書き終えないといけないとき（書いている途中のものがあれば、今のキャラで書き直す）
export function flushAutosave(now?: boolean) {
  clearTimeout(S.autosaveTimer);
  if (now === true) {
    if (!S.autosaveDirty && !writing[AUTO_KEY]) return;
    S.autosaveDirty = false;
    writeStoredNow(AUTO_KEY, saveObject());
    return;
  }
  if (!S.autosaveDirty) return;
  S.autosaveDirty = false;
  writeStored(AUTO_KEY, saveObject());
}
